import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    document.addEventListener('priority:updated', this.updatePriorityIcon.bind(this))
  }

  disconnect() {
    document.removeEventListener('priority:updated', this.updatePriorityIcon.bind(this))
  }

  updatePriorityIcon(event) {
    const { taskId, priority } = event.detail
    const taskElement = document.querySelector(`[data-task-priority-update-flags-task-id="${taskId}"]`)
    if (taskElement) {
      let iconElement = taskElement.querySelector('i')
      if (priority) {
        if (!iconElement) {
          // Create the icon element if it doesn't exist
          iconElement = document.createElement('i')
          iconElement.className = 'fas fa-pennant'
          taskElement.appendChild(iconElement)
        }
        iconElement.className = `fas fa-pennant ${priority}`
      } else {
        // Remove the icon element if priority is nil
        if (iconElement) {
          iconElement.remove()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task-priority-update-flags-controller.js